import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { NavLink } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { getNotificationsRequest, readNotification } from '../../../store/actions/rightBar';
import classes from './notification.module.scss';
import accountHelpers from '../../../utils/accountHelpers';
import Loader from '../../_common/Loader/Loader';
import { setScrollingToNoteId } from '../../../store/actions/script';

let firstLoad = true;

const Notifications = () => {
  const dispatch = useDispatch();
  const { notificationList, notificationTotalPage, notificationCurrentPage } = useSelector((store) => store.rightBar);
  const [scrollLoading, setScrollLoading] = useState(false);

  useEffect(() => {
    (async () => {
      if (_.isEmpty(notificationList)) {
        await dispatch(getNotificationsRequest(1));
      }
      firstLoad = false;
    })();
  }, []);

  const notificationPageScroll = async (e) => {
    if (!scrollLoading && e.target.scrollTop + e.target.getBoundingClientRect().height + 10 >= e.target.scrollHeight) {
      setScrollLoading(true);

      if (notificationTotalPage >= notificationCurrentPage + 1) {
        await dispatch(getNotificationsRequest(notificationCurrentPage + 1));
      }

      setScrollLoading(false);
    }
  };

  const readNote = (id) => {
    dispatch(readNotification(id));
    dispatch(setScrollingToNoteId(id));
  };

  return (
    firstLoad ? <Loader />
      : (
        <div className={classes.notification_wrapper} onScroll={notificationPageScroll}>
          {notificationList
            .map((d, i) => (
              <NavLink
                key={`${d.noteId}_${d.scriptId}_${i}`}
                to={`/scripts/${d.scriptId}`}
                onClick={() => readNote(d.noteId)}
              >
                <div className={classes.notification_user}>
                  <p className={` ${d.showed === true ? classes.active : ''}`}>
                    {d.User.name}
                    {' '}
                    add notes
                    {' '}
                    {d.scriptNote.note}
                  </p>

                  {d.showed === true && d.User.id !== accountHelpers.getUser().id && <span />}

                  <p>
                    {moment(d.createdAt).calendar({
                      sameDay: 'LT',
                      nextDay: 'DD.MM  LT',
                      nextWeek: 'DD.MM  LT',
                      lastDay: 'DD.MM  LT',
                      lastWeek: 'DD.MM  LT',
                      sameElse: 'DD.MM  LT',
                    })}
                  </p>
                </div>
              </NavLink>
            ))}

          {scrollLoading
          && (
          <div className={classes.notification_load}>
            <Loader size={24} />
          </div>
          )}
        </div>
      )

  );
};

export default Notifications;
